import { render, staticRenderFns } from "./MonitorItem.vue?vue&type=template&id=3e1fad4e&scoped=true&"
import script from "./MonitorItem.vue?vue&type=script&lang=js&"
export * from "./MonitorItem.vue?vue&type=script&lang=js&"
import style0 from "./MonitorItem.vue?vue&type=style&index=0&id=3e1fad4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fad4e",
  null
  
)

export default component.exports